import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { observer } from "mobx-react-lite";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import type DeadLetterTopicsSearchListViewModel from "viewModels/administration/deadLetterTopics/search/deadLetterTopicsSearchListViewModel";
import FilterView from "views/common/filter";
import { translateGeneral } from "utils/localizations";
import NumberRangeInputControl from "controls/numberRangeInput";
import DateRangeInputControl from "controls/dateRangeInput";

export interface DeadLetterTopicsSearchFilterProps {
  vm: DeadLetterTopicsSearchListViewModel;
}

const DeadLetterTopicsSearchFilters = observer((props: DeadLetterTopicsSearchFilterProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("originalProducedAtRange")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="originalProducedAtRange" />
        </Form.Group>
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("messageType")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="messageType"
            items={vm.messageTypeOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("deliveryAttemptsRange")}</Form.Label>
          <NumberRangeInputControl
            target={vm.filter}
            property="deliveryAttemptsRange"
            placeholder={translateGeneral("search")}
            min={0}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default DeadLetterTopicsSearchFilters;
